import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from "classnames"
import JobItems from './JobItems'
import JobReGenerate from './re-generate/JobReGenerate'
import showDateTime from "../../../shared/ShowDateTime"
import JobStatistical from "./JobStatistical"

class JobTableRow extends Component {
    render() {
        const {item, index, reloadListSessions} = this.props
        const {session_status: status, meta} = item

        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending',
            'processing progress-bar-animated progress-bar-striped': status === 'processing',
            'failed': status === 'failed' || status === 'error',
            'cancelled': status === 'cancelled',
            'done': status === 'done',
        })

        return (
            <tr className="JobTableRow">
                <td>{index + 1}</td>
                <td><JobItems sessionId={item._id}/></td>
                <td>{meta !== undefined && (meta.batch_name || '')}</td>
                <td>{showDateTime(item.created_at)}</td>
                <td className='StatusJob'>
                    <span className={`badge ${color} badge-pill`}>{item.session_status}</span>
                </td>
                <td className="JobStatistical text-center">
                    <JobStatistical item={item} />
                </td>
                <td className="colAction">
                    {(item.session_status === 'error') &&
                    <JobReGenerate sessionId={item._id} reloadListSessions={reloadListSessions}/>
                    }
                </td>
            </tr>
        )
    }
}

JobTableRow.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    reloadListSessions: PropTypes.func.isRequired
}

export default JobTableRow